export default "__VITE_ASSET__DepnbNb9__"